import type { ICupomLoja, TipoDesconto } from "interfaces/loja";

export interface CupomFormValues {
  codigo: string;
  tipo: TipoDesconto | "";
  valor: string;
  inicioEm: string;
  fimEm: string;
  ativo: boolean;
  subtotalMinimo: string;
  limiteUsoGlobal: string;
  limiteUsoPorUsuario: string;
}

export const initialValues: CupomFormValues = {
  codigo: "",
  tipo: "",
  valor: "",
  inicioEm: "",
  fimEm: "",
  ativo: true,
  subtotalMinimo: "",
  limiteUsoGlobal: "",
  limiteUsoPorUsuario: "",
};

export function initialValuesEdit(data: ICupomLoja | null): CupomFormValues {
  if (!data) return initialValues;
  const rawTipo = data.tipo as string;
  const tipo = rawTipo === "FIXO" ? "VALOR_FIXO" : (rawTipo as TipoDesconto);
  return {
    codigo: data.codigo ?? "",
    tipo: tipo ?? "",
    valor: data.valor != null ? String(data.valor) : "",
    inicioEm: data.inicioEm ? String(data.inicioEm).slice(0, 10) : "",
    fimEm: data.fimEm ? String(data.fimEm).slice(0, 10) : "",
    ativo: Boolean(data.ativo),
    subtotalMinimo:
      data.subtotalMinimo != null ? String(data.subtotalMinimo) : "",
    limiteUsoGlobal:
      data.limiteUsoGlobal != null ? String(data.limiteUsoGlobal) : "",
    limiteUsoPorUsuario:
      data.limiteUsoPorUsuario != null ? String(data.limiteUsoPorUsuario) : "",
  };
}
